var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scratchcontainer"},_vm._l((_vm.scratch_data),function(item){return _c('div',{key:item.pk,staticClass:"workContainer"},[_c('ScratchWorkItem',{attrs:{"dic":item,"data-type":_vm.data_type}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }